import React, { CSSProperties, useEffect, useState } from 'react'
import { Sparkline } from 'components/Charts_Sparkline'
import './styles.scss'
import { addDays, formatSwissDate } from 'components/Charts_Assets'

const dateformat: { [key: string]: 'numeric' | 'long' | undefined } = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  weekday: 'long'
}

type situationDataElement = {
  v: number
  d: string
  ave7: number
  sum7: number
  c: number
  cAve7: number
  cSum7: number
}
type situationDataElementRe = { v: number; d: string; range: number[] }
type drawDataType = {
  cases: situationDataElement[]
  death: situationDataElement[]
  hosp: situationDataElement[]
  re: situationDataElementRe[]
  lastCases: situationDataElement
  lastDeath: situationDataElement
  lastHosp: situationDataElement
  lastRe: situationDataElementRe
}

export const Facts = ({}: {}) => {
  const [drawData, setDrawData] = useState<drawDataType | undefined>()

  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-Situation.json'
    )
      .then(response => response.json())
      .then(data => {
        setDrawData(data as drawDataType)
      })
  }, [])

  const date = drawData ? drawData.lastCases.d : ''
  const lastCases = drawData ? drawData.lastCases.v : 0
  const aveCases = drawData ? drawData.lastCases.ave7 : 0
  const sumCases = drawData ? drawData.lastCases.sum7 : 0
  const lastDeath = drawData ? drawData.lastDeath.v : 0
  const aveDeath = drawData ? drawData.lastDeath.ave7 : 0
  const sumDeath = drawData ? drawData.lastDeath.sum7 : 0
  const re = drawData ? drawData.lastRe.range.join(' - ') : 0
  const lastRe = drawData ? drawData.lastRe.v : 0
  const reDate = drawData ? drawData.lastRe.d : 0
  const lastHosp = drawData ? drawData.lastHosp.v : 0
  const lastHospChange = drawData ? drawData.lastHosp.c : 0
  const lastCasesChange = drawData ? drawData.lastCases.c : 0
  const lastDeathChange = drawData ? drawData.lastDeath.c : 0
  const lastDeathAveChange = drawData ? drawData.lastDeath.cAve7 : 0
  const lastCasesAveChange = drawData ? drawData.lastCases.cAve7 : 0
  const lastDeathSumChange = drawData ? drawData.lastDeath.cSum7 : 0
  const lastCasesSumChange = drawData ? drawData.lastCases.cSum7 : 0
  const daterange = [
    '2022-01-01',
    drawData
      ? drawData.cases[drawData.cases.length - 1].d
      : new Date().toISOString().split('T')[0]
  ]
  const datefilter = f =>
    new Date(f.d) >= new Date(daterange[0]) &&
    new Date(f.d) <= new Date(daterange[1])

  let currentDate = formatSwissDate(date, 'extended')

  return (
    <div className='Facts'>
      {!drawData && <>Daten werden geladen...</>}
      {drawData && (
        <>
          <div className='title'>Situation im Kt. Zürich</div>
          {date && <div className='date'>{currentDate}</div>}
          <div className='mobilesidekey'>
            <div className=''>Bestätigte Fälle</div>
            <div className=''>Todesfälle</div>
          </div>
          <div className='row'>
            <div className='rowtitle'>Täglich </div>
            <Fact
              label='Bestätigte Fälle'
              value={lastCases}
              valueStyle={{ color: '#202346', backgroundColor: '#FFE462' }}
              change={lastCasesChange}
              changeText={`% gleicher Tag letzte Woche`}
              sparklinerange={daterange}
              sparklinedata={drawData.cases.filter(datefilter).map(m => m.v)}
            />
            <Fact
              label='Todesfälle'
              value={lastDeath}
              valueStyle={{ color: '#fff', backgroundColor: '#D3343F' }}
              change={lastDeathChange}
              changeText={`% gleicher Tag letzte Woche`}
              sparklinerange={daterange}
              sparklinedata={drawData.death.filter(datefilter).map(m => m.v)}
            />
          </div>
          <div className='row'>
            <div className='rowtitle'>Durchschnitt der letzten 7 Tage </div>
            <Fact
              label='Bestätigte Fälle'
              value={aveCases}
              valueStyle={{ color: '#202346', backgroundColor: '#FFE462' }}
              change={lastCasesAveChange}
              changeText={`% zum Vortag`}
              sparklinedata={drawData.cases.filter(datefilter).map(m => m.ave7)}
            />
            <Fact
              label='Todesfälle'
              value={aveDeath}
              valueStyle={{ color: '#fff', backgroundColor: '#D3343F' }}
              change={lastDeathAveChange}
              changeText={`% zum Vortag`}
              sparklinedata={drawData.death.filter(datefilter).map(m => m.ave7)}
            />
          </div>
          <div className='row'>
            <div className='rowtitle'>Summe der letzten 7 Tage </div>
            <Fact
              label='Bestätigte Fälle'
              value={sumCases}
              valueStyle={{ color: '#202346', backgroundColor: '#FFE462' }}
              change={lastCasesSumChange}
              changeText={`% zur Vorwoche`}
              sparklinedata={drawData.cases.filter(datefilter).map(m => m.sum7)}
            />
            <Fact
              label='Todesfälle'
              value={sumDeath}
              valueStyle={{ color: '#fff', backgroundColor: '#D3343F' }}
              change={lastDeathSumChange}
              changeText={`% zur Vorwoche`}
              sparklinedata={drawData.death.filter(datefilter).map(m => m.sum7)}
            />
          </div>
          {/* <div className='row half '>
            <div className='rowtitle half'>R-Wert</div>
            <div className='rowtitle sec'>Aktuell im Spital</div>

            <FactNoChart
              value={
                <>
                  <b>{re}</b> ({lastRe})
                </>
              }
              valueStyle={{ color: '#fff', backgroundColor: '#7A3F77' }}
            />
          </div> */}
          <div className='row half right'>
            <div className='rowtitle sec'>Aktuell im Spital</div>

            <FactNoChart
              value={<b>{lastHosp}</b>}
              valueStyle={{ color: '#fff', backgroundColor: '#60B9B7' }}
              change={lastHospChange}
              changeText={`% zur Vorwoche`}
            />
          </div>
          <div className='row' style={{ clear: 'both' }}>
            <div className='source'>
              {' '}
              Quelle:{' '}
              <a
                href='https://raw.githubusercontent.com/openZH/covid_19/master/fallzahlen_kanton_total_csv_v2/COVID19_Fallzahlen_Kanton_ZH_total.csv'
                target='_blank'
              >
                Gesundheitsdirektion Kanton Zürich
              </a>
              , Todesfälle:{' '}
              <a
                href='https://www.covid19.admin.ch/de/epidemiologic/death'
                target='_blank'
              >
                BAG
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

const Fact = ({
  label = '',
  value = 1234.5,
  valueStyle = { color: '#202346', backgroundColor: '#FFE462' },
  change = 0,
  changeText = '',
  sparklinerange,
  sparklinedata
}: {
  label?: string
  change?: number
  changeText?: string
  value?: number | string | JSX.Element
  valueStyle?: CSSProperties
  sparklinerange?: string[]
  sparklinedata?: number[]
}) => {
  return (
    <div className='col'>
      {sparklinerange && (
        <div className='sparklinerange'>
          <div className='left' />
          <div className='middle'>
            {formatSwissDate(sparklinerange[0], 'short')}
          </div>
          <div className='right'>
            {formatSwissDate(sparklinerange[1], 'short')}
          </div>
        </div>
      )}
      <div className='label'>
        <span>{label}</span>
      </div>
      <div className='sparkline'>
        <Sparkline
          isMobile={window.innerWidth < 600}
          values={sparklinedata || []}
        />
      </div>
      <div className='value' style={valueStyle}>
        <span> {value}</span>
      </div>
      <div className='change'>
        {change > 0 ? '+' : ''}
        {change.toLocaleString()} {changeText}
      </div>
    </div>
  )
}
const FactNoChart = ({
  label,
  value = 1234.5,
  valueStyle = { color: '#202346', backgroundColor: '#FFE462' },
  change,
  changeText = ''
}: {
  label?: string | JSX.Element
  change?: number
  changeText?: string
  value?: number | string | JSX.Element
  valueStyle?: CSSProperties
}) => {
  return (
    <div className='col noChart'>
      {label && (
        <div className='label'>
          {' '}
          <span>{label}</span>
        </div>
      )}
      <div className='value' style={valueStyle}>
        <span> {value}</span>
      </div>

      <div className='change'>
        {change && (
          <>
            {change > 0 ? '+' : ''}
            {change.toLocaleString()} {changeText}{' '}
          </>
        )}
        {!change && window.innerWidth > 600 && <>&nbsp;</>}
      </div>
    </div>
  )
}
